<template src="../templates/normal_fcont_58.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import CreativePrint from '../components/CreativePrint'
import CreatorProfileMaikaKokubo from '../components/CreatorProfileMaikaKokubo'
import { Carousel,Slide } from 'uiv'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink'
import AppDownloadCreative from '../components/AppDownloadCreative'
import AppDownloadiPrint from '../components/AppDownloadiPrint'
export default {
  name: 'app',
  components: {
   LabelFunMessage,FuncSearchRecommendLink,Carousel,Slide,
   FuncSearchGalleryQR,CreativePrint,CreatorProfileMaikaKokubo,AppDownloadCreative,AppDownloadiPrint
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['58-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['58-2']}
    ]};
  }
};
</script>
<style />


